<script type="ts">
  import Chart from "../components/game/chart.svelte";
  import { store, gameState } from "./../store";

  let game = $store.find((g) => g.id == $gameState.currentGame);

  $: inputsAreValid = game.players.some((p) => p.newRoundPoints === undefined);

  const onAddRound = () => {
    game.rounds++;

    game.players.forEach((p) => {
      p.roundPoints.push(p.newRoundPoints);
      p.totalPoints += p.newRoundPoints;
      p.statsPoints.push(p.totalPoints);

      // reset newRoundPoints
      p.newRoundPoints = undefined;
    });

    // sort players by total points
    game.players = game.players.sort((a, b) => {
      return a.totalPoints - b.totalPoints;
    });

    // update store
    let gameIndex = $store.findIndex((g) => g.id == $gameState.currentGame);
    $store[gameIndex] = game;
  };
</script>

<div class="overflow-x-auto">
  <table class="table w-full text-center ">
    <thead>
      <tr>
        <th class="text-left">
          <p>Spieler*in</p>
        </th>
        <th>
          <p>Neue Runde</p>
        </th>
        <th>
          <p>Gesamt</p>
        </th>
        {#each Array(game.rounds) as _, i}
          <td>
            {i + 1}
          </td>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each game.players as player, i}
        <tr>
          <th class="text-left">
            <p>
              {player.icon}
              {player.name}
            </p>
          </th>
          <td>
            <input
              type="number"
              placeholder="..."
              class="w-full max-w-xs text-center input"
              bind:value={player.newRoundPoints}
            />
          </td>
          <td>
            <p class="font-bold">
              {player.totalPoints}
            </p>
          </td>
          {#each player.roundPoints as roundPoint}
            <td>
              <p>
                {roundPoint}
              </p>
            </td>
          {/each}
        </tr>
      {/each}
      <tr>
        <td />
        <button
          class="my-2 btn btn-primary"
          disabled={inputsAreValid}
          on:click={onAddRound}>Hinzufügen</button
        >
      </tr>
    </tbody>
  </table>
</div>

<div class="mt-2 rounded-lg collapse collapse-arrow bg-base-200">
  <input type="checkbox" />
  <div class="text-xl font-medium collapse-title">
    Statistik
  </div>
  <div class="collapse-content">
    <Chart />
  </div>
</div>
